var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_c('div',{staticClass:"Container"},[(_vm.isLoading)?_c('div',{staticClass:"Loader"},[_c('spinner')],1):_c('router-view')],1),_c('notices-container'),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }